import config from "../utils/config";
const { baseUrl } = config;

// Auth Url
export const loginUrl = baseUrl + "/auth/user/login";
export const signUpSendOtpUrl = baseUrl + "/auth/user/signup/send-otp";
export const signUpVerifyOtpUrl = baseUrl + "/auth/user/signup/verify-otp";
export const registerUrl = baseUrl + '/auth/user/signup'
export const fgSendOtpUrl = baseUrl + '/auth/user/fg-sendotp'
export const fgVerifyOtpUrl = baseUrl + '/auth/user/fg-verifyotp'
export const fgResetPassUrl = baseUrl + '/auth/user/fg-reset'

// Google Auth
export const gAuthLoginUrl = baseUrl + '/auth/2fa/user/verify-login'
export const gAuthUserDataUrl = baseUrl + '/profile/user/2fa/data'
export const gAuthEnableUrl = baseUrl + '/profile/2fa/user/enable'
export const gAuthDisableUrl = baseUrl + '/profile/2fa/user/disable'

// Profile
export const profileViewUrl = baseUrl + '/profile/view-by-user'
export const profileChangePhotoUrl = baseUrl + '/profile/user/change-profile-photo'    
export const profilePassChangeUrl = baseUrl + '/profile/user/change-password'
export const profileUserDeleteUrl = baseUrl + '/profile/user/delete-account'
export const referalHistoryUrl = baseUrl + '/referral/history'
export const referraIncomeUrl = baseUrl + '/referral/referred-users'
export const clientGetChatsUrl = baseUrl + '/support/client/get/chats'

// KYC
export const kycEmailOtpUrl = baseUrl + '/kyc/send-email-otp'
export const kycEmailVerifyUrl = baseUrl + '/kyc/verify-email-otp'
export const kycAddPhoneUrl = baseUrl + '/kyc/add-phone'
export const kycTrackUrl = baseUrl + '/kyc/track'
export const kycBankVerifyUrl = baseUrl + '/kyc/verify-bank'
export const kycUpiVerifyUrl = baseUrl + '/kyc/verify-upi'
export const kycNomineeVerifyUrl = baseUrl + '/kyc/verify-nominee'
export const kycAadhaarVerifyUrl = baseUrl + '/kyc/verify-aadhar'
export const kycPanVerifyUrl = baseUrl + '/kyc/verify-pan'
export const kycFaceVerifyUrl = baseUrl + '/kyc/verify-face'
export const kycNationVerifyUrl = baseUrl + '/kyc/verify-nation-id'
export const kycPassportVerifyUrl = baseUrl + '/kyc/verify-passport'

// WhiteList
export const whiteListAddAddressUrl = baseUrl + '/whitelist/add/address'         //post
export const whiteListDeleteAddressUrl = baseUrl + '/whitelist/delete/address'   //delete
export const whiteListGetAddressUrl = baseUrl + '/whitelist/get/address'         //get
export const whiteListChainsUrl = baseUrl + '/currency/get-chains'               //get


// Transaction
export const transUserBalanceListUrl = baseUrl + '/transaction/user-balance-list'                       //get
export const transGetChainsUrl = baseUrl + '/transaction/get-chains-in-transaction'                     //get
export const transGetChainsDepoAddrUrl = baseUrl + '/transaction/get-chain-deposit-address'             //get
export const transGetChainsWithdAddrUrl = baseUrl + '/transaction/get-chain-withdraw-address'           //get
export const transWithdModelCommissionDataUrl = baseUrl + '/transaction/withdraw-model-commission-data' //get

export const transRaiseWithdrawRequestUrl = baseUrl + '/transaction/raise-withdraw-request'             //post
export const transRaiseTransferRequestUrl = baseUrl + '/transaction/raise-transfer-request'             //post
export const transCurrenciesUrl = baseUrl + '/transaction/currencies'                                   //get
export const transGetDepositsListUrl = baseUrl + '/transaction/get-deposits-list'                       //post
export const transGetWithdrawsListUrl = baseUrl + '/transaction/get-withdrawals-list'                   //post
export const transGetWalletsListUrl = baseUrl + '/transaction/get-wallets-list'                         //post
export const transGetSpotListUrl = baseUrl + '/transaction/get-spots-list'                              //post

// Trade
export const transGetTradeHistoryUrl = baseUrl + '/transaction/get-trades-history'                         //post

// INR 
export const inrAdminAccountGetUrl = baseUrl + '/inr/admin-account/get'
export const inrDepositUrl = baseUrl + '/inr/deposit'
export const inrWithdrawUrl = baseUrl + '/inr/withdraw'

// Support
export const supportCreateTicketUrl = baseUrl + '/support/create-ticket' //post
export const supportSubjectsUrl = baseUrl + '/support/subjects' //get
export const supportMyTicketsUrl = baseUrl + '/support/my-tickets' //get
export const supportReplyUrl = baseUrl + '/support/reply' //post

// Stacking
export const stakingGetPlansUrl = baseUrl + '/stacking/get-stack-plans-by-client'    //get
export const stakingMyStakesUrl = baseUrl + '/stacking/my-stacks'                    //get
export const stakingStakeUrl = baseUrl + '/stacking/stake'                           //post
export const stakingClaimUrl = baseUrl + '/stacking/claim'                           //post

// Launchpad
export const launchpadAddUrl = baseUrl + '/launchpad/add'                            //post
export const launchpadListingUrl = baseUrl + '/launchpad/listed'                     //get
export const launchpadBuyUrl = (id) => `${baseUrl}/launchpad/${id}/buy`              //post
export const launchpadMyPurchasesUrl = baseUrl + '/launchpad/my-purchases'           //get

// Listing
export const listingAddUrl = baseUrl + '/listing/add'                                //post
export const listingTodayUrl = baseUrl + '/listing/today'                            //get
export const listingUpcomingUrl = baseUrl + '/listing/upcoming'                      //get
export const listingMyUrl = baseUrl + '/listing/my'                                  //get

// Contact Us
export const contactUsQueryUrl = baseUrl + '/contact/submit'                         //post
